import { useEffect, useState } from "react";
import { useUser } from "@context/contexts";
import { loadChatwootWidget } from "@utils/chatwoot";
import { useChatwootIdentity } from "@hooks/useChatwootIdentity";

const CHATWOOT_BASE_URL = import.meta.env.VITE_CHATWOOT_BASE_URL;
const CHATWOOT_WEBSITE_TOKEN = import.meta.env.VITE_CHATWOOT_WEBSITE_TOKEN;

// Mounted once for every visitor, logged in or anonymous (mirrors how
// <Fireworks /> is mounted in UserContext.jsx). Renders nothing itself.
// If the env vars are missing, or the identity fetch fails or is disabled,
// this degrades to a plain anonymous widget rather than breaking anything.
const ChatwootWidget = () => {
    const { userData } = useUser();
    const { data: identity } = useChatwootIdentity();
    const [chatwoot, setChatwoot] = useState(null);

    useEffect(() => {
        let cancelled = false;
        loadChatwootWidget({ baseUrl: CHATWOOT_BASE_URL, websiteToken: CHATWOOT_WEBSITE_TOKEN })
            .then((instance) => {
                if (!cancelled) {
                    setChatwoot(instance);
                }
            });
        return () => {
            cancelled = true;
        };
    }, []);

    useEffect(() => {
        if (!chatwoot) {
            return;
        }

        if (userData && identity?.identifier && identity?.identifier_hash) {
            chatwoot.setUser(identity.identifier, {
                identifier_hash: identity.identifier_hash,
                email: userData.email,
                name: userData.lichessId,
            });
        } else if (!userData) {
            chatwoot.reset();
        }
    }, [chatwoot, userData, identity]);

    return null;
};

export default ChatwootWidget;
